<template>
  <div :class="className" :style="{height:height,width:width}" id="myChart2"/>
</template>

<script>
import { debounce } from '@/utils'

const animationDuration = 6000

export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    mainChart: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    window.removeEventListener('resize', this.__resizeHandler)
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setfontSize(res) {
      const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body
          .clientWidth;
      if (!clientWidth) return;
      let fontSize = clientWidth / 1920;
      return parseInt(res * fontSize);
    },
    initChart() {
        let myChart = this.$echarts.getInstanceByDom(document.getElementById("myChart2"));
        if (myChart == null) {
            this.chart = this.$echarts.init(this.$el, 'macarons')
        }
      var xdata = [], ydata = [];
      this.mainChart.forEach((item,index)=>{
          if(index<10){
            xdata.push(item.thingregcode);
            ydata.push(item.totalfinishweight);  
          }
      })
      this.chart.setOption({
        grid: {
            top: '10%',
            left: '2%',
            right: '2%',
            bottom: '2%',
            containLabel: true
        },
        toolbox: {
            show: false,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
                magicType: {
                    show: true,
                    type: ['line', 'bar']
                },
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params) {
                var htmlStr = '';
                htmlStr += '<div><span style="color:#000;">' + params[0].axisValue + '</span><br/> ';
                htmlStr += '<span style="width: 8px;height: 8px;margin-right:5px; display:inline-block;border-radius: 50%;background-color:'+params[0].color.value+'"></span>';
                htmlStr += '<span style="color:#000;margin-right:20px">' + params[0].seriesName + '</span><span style="color:#000;font-weight:bold;">' + params[0].value + ' 吨</span><br/>';
                return  htmlStr
            },
        },
        yAxis: {
            type: 'category',
            data: xdata,
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,0.1)",
                    width: 0,
                    type: "solid"
                }
            },
            inverse:true,
            axisLabel: { //x轴文字的配置
                show: true,
                textStyle: {
                    color: "#fff",
                    fontSize: this.setfontSize(13)
                },
            },
        },
        xAxis: {
            type: 'value',
            position: 'left',
            // name: '运输重量',    
            splitLine: { //分割线配置
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,0.1)",
                }
            },
            axisLabel: { //
                show: true,
                interval: 0,
                rotate:30,
                textStyle: {
                    color: "#aaa",
                    fontSize: this.setfontSize(14)
                },
                // formatter: '{value} T'
            },
        },
        series: [
        {
            name: '运输重量',
            data: ydata,
            type: 'bar',
            barMaxWidth: this.setfontSize(20),
            itemStyle: {
                color: {
                    value:'rgba(0,182,239,1)',
                    type: 'linear',
                    x: 1, //右
                    y: 0, //下
                    x2: 0, //左
                    y2: 0, //上
                    colorStops: [{
                            offset: 0,
                            color: 'rgba(0,182,239,1)' // 0% 处的颜色
                        },
                        {
                            offset: 1,
                            color: 'rgba(0,182,239,0)' // 100% 处的颜色
                        }
                    ]
                },
                borderRadius:[0,this.setfontSize(20),this.setfontSize(20),0]
            },
            label: {
                show: true,
                // padding: [0,this.setfontSize(20),0,0], // 汉字距离柱状图间距
                color: '#fff',
                // position: 'top',
                fontSize: this.setfontSize(12),
                formatter:"{c} 吨",
            },
        },
        ]
      })
    }
  },
  watch: {
    'mainChart'(newVal, oldVal) {
      if (newVal!=oldVal) {
        this.initChart()
      }
    }
  }
}
</script>
